import Checkbox, { CheckboxIcon, getTextColor } from './Checkbox';

export { CheckboxIcon, getTextColor };
export default Checkbox;
